import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import {
	FieldModal
	// TemplateNewModal
} from '../../../modals';

@Component({
	selector: 'app-document-template-list',
	templateUrl: './document-template-list.component.html',
	styleUrls: [ './document-template-list.component.scss' ]
})
export class DocumentTemplateListComponent implements OnInit {
	filter: AppFilter = new AppFilter();
	pending: boolean;
	totalItems: number = 5;
	rows: number = 2;
	currentPage: number = 1;
	maxSize: number = 7;
	documentTemplates: Array<any>;
	constructor(private location: Location, private modalService: SuiModalService) {}
	goBack() {
		this.location.back();
	}
	newTemplate($event) {
		let newProduct = $event.dragData;
		let relname = Math.random().toString(36).substr(2, 5);
		newProduct.id = `${newProduct.name}_${relname}`;
		newProduct['relevantGroup'] = { relComp: '', relOperator: '' };
		newProduct['constraintGroup'] = { constOperator: '', constStatus: '' };
		newProduct['hint'] = '';
		this.modalService
			.open(new FieldModal('Edit Activity', newProduct, [], false, ModalSize.Tiny))
			.onApprove((eq) => {
				// this.selectedCertificateHolder = eq;
				// this.startApplication(eq);
			})
			.onDeny(() => console.log('add certificate holder cancel'));
	}
	deleteTemplate() {
		this.modalService
			.open(
				new ConfirmModal(
					'Delete document template?',
					'Are you sure you want to delete this document template?',
					ModalSize.Tiny
				)
			)
			.onApprove(() => {})
			.onDeny(() => {});
	}
	searchRecords(event) {}
	displayRecords(event) {}
	sortRecords(event) {}
	nextPage(event) {}
	onDelete(event) {
		this.modalService
			.open(
				new ConfirmModal(
					'Delete document template?',
					'Are you sure you want to delete this document template?',
					ModalSize.Tiny
				)
			)
			.onApprove(() => {})
			.onDeny(() => {});
	}
	ngOnInit(): void {}
}
